// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3jiny","bigColWidth":"Table_bigColWidth__1SrKr","biggerColWidth":"Table_biggerColWidth__2jsJe","row":"Table_row__1hipA","col":"Table_col__IZtlY"};